import {Utils} from "../common/utils";
import {
    CHECK_POSITION_REPORT_PARAMETER,
    CREATE_REPORT, CREATE_REPORT_TEMPLATE,
    DELETE_REPORT, DELETE_REPORT_TEMPLATE, FIND_REPORT_BY_CODE, GET_DATA_API_PARAM,
    GET_DATA_REPORT, GET_DATA_REPORT_PARAMETER, GET_DESIGN_TEMPLATE_REPORT_TEMPLATE, GET_OPTIONS_API,
    GET_OPTIONS_CONN,
    GET_OPTIONS_GROUP, GET_OPTIONS_REFRESH_BY, GET_TEMPLATE, SEARCH_REPORT_TEMPLATE,
    UPDATE_REPORT, UPDATE_REPORT_PARAMETER, UPDATE_REPORT_TEMPLATE,
} from "../../constants/AppPath";

export class ReportService {
    /*
    Viết các hàm gọi API ở đây
    */
    searchReport(data) {
        return Utils.post(GET_DATA_REPORT, data, null, true);
    }

    findReportByCode(code) {
        return Utils.get(FIND_REPORT_BY_CODE, {code: code}, null, false)
    }

    getOptionsGroup() {
        return Utils.get(GET_OPTIONS_GROUP, null, null);
    }

    getTemplate(id) {
        return Utils.get(GET_TEMPLATE, {"id": id}, null, true);
    }

    getOptionsConn() {
        return Utils.get(GET_OPTIONS_CONN, null, null);
    }

    insertReportDetail(data) {
        return Utils.post(CREATE_REPORT, data, null, true);
    }

    updateReportDetail(data) {
        return Utils.post(UPDATE_REPORT, data, null, true);
    }

    deleteReportDetail(data) {
        return Utils.post(DELETE_REPORT, data, null, true);
    }

    getDataConfigure(reportId) {
        return Utils.get(GET_DATA_REPORT_PARAMETER, {"reportId": reportId}, null, true);
    }

    getOptionsAPI() {
        return Utils.get(GET_OPTIONS_API, null, null);
    }

    getOptionsRefreshBy(reportId) {
        return Utils.get(GET_OPTIONS_REFRESH_BY, {"reportId": reportId}, null);
    }

    getDataAPIParam(rpApiId) {
        return Utils.get(GET_DATA_API_PARAM, {"rpApiId": rpApiId}, null);
    }

    updateReportParam(data) {
        return Utils.post(UPDATE_REPORT_PARAMETER, data, null, true);
    }

    checkExistPos(data) {
        return Utils.post(CHECK_POSITION_REPORT_PARAMETER, data, null, true);
    }

    searchReportTemplate(reportId) {
        return Utils.get(SEARCH_REPORT_TEMPLATE, {reportId: reportId}, null, true);
    }

    getDesignTemplateReportTemplate(templateId) {
        return Utils.get(GET_DESIGN_TEMPLATE_REPORT_TEMPLATE, {templateId: templateId}, null, true);
    }

    createReportTemplate(data) {
        return Utils.post(CREATE_REPORT_TEMPLATE, data, null, true);
    }

    updateReportTemplate(data) {
        return Utils.post(UPDATE_REPORT_TEMPLATE, data, null, true);
    }

    deleteReportTemplate(templateId) {
        return Utils.post(DELETE_REPORT_TEMPLATE,  templateId, null, true);
    }
}